import { Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import Privacy from './pages/Privacy'
import Cookie from './pages/Cookie'
import Termini from './pages/Termini'
import PrivacyClienti from './pages/PrivacyClienti'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import NotFound from './pages/NotFound'
import { CookieConsentProvider } from './components/cookie/CookieConsentContext'
import CookieBanner from './components/cookie/CookieBanner'
import { AuthProvider } from './components/auth/AuthContext'
import { ContactModalProvider } from './components/ContactModalContext'
import ContactModal from './components/ContactModal'

// Admin pages
import AdminLogin from './pages/admin/Login'
import AdminDashboard from './pages/admin/Dashboard'
import AdminArticles from './pages/admin/Articles'
import AdminArticleEditor from './pages/admin/ArticleEditor'
import AdminCookies from './pages/admin/Cookies'

// Privacy versions
import PrivacyV101 from './pages/privacy/PrivacyV101'
import PrivacyV102 from './pages/privacy/PrivacyV102'
import PrivacyV103 from './pages/privacy/PrivacyV103'
import PrivacyV104 from './pages/privacy/PrivacyV104'

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation()
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  
  return null
}

// Wrapper component to conditionally apply Layout
function AppRoutes() {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/admin')

  const routes = (
    <Routes>
      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/articles" element={<AdminArticles />} />
      <Route path="/admin/articles/new" element={<AdminArticleEditor />} />
      <Route path="/admin/articles/:id/edit" element={<AdminArticleEditor />} />
      <Route path="/admin/cookies" element={<AdminCookies />} />

      {/* Public routes */}
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacy/v1-0-1" element={<PrivacyV101 />} />
      <Route path="/privacy/v1-0-2" element={<PrivacyV102 />} />
      <Route path="/privacy/v1-0-3" element={<PrivacyV103 />} />
      <Route path="/privacy/v1-0-4" element={<PrivacyV104 />} />
      <Route path="/cookie" element={<Cookie />} />
      <Route path="/termini-e-condizioni-generali-duso" element={<Termini />} />
      <Route path="/informativa-privacy-clienti-e-fornitori" element={<PrivacyClienti />} />
      <Route path="/il-blog-di-carletto" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )

  // Don't wrap admin routes with Layout
  if (isAdminRoute) {
    return routes
  }

  return <Layout>{routes}</Layout>
}

function App() {
  return (
    <AuthProvider>
      <CookieConsentProvider>
        <ContactModalProvider>
          <ScrollToTop />
          <AppRoutes />
          <CookieBanner />
          <ContactModal />
        </ContactModalProvider>
      </CookieConsentProvider>
    </AuthProvider>
  )
}

export default App
